import { compose } from 'redux';
import type { ElementType } from 'react';
import WithErrorBoundary from '../error-boundaries/higher-order-components/WithErrorBoundary';
import { withAbTests } from '../ab-tests/higher-order-components/WithAbTests';

const withPageWrappers = (WrappedComponent: ElementType) =>
  compose<ElementType>(WithErrorBoundary, withAbTests)(WrappedComponent);

export default withPageWrappers;
